import type { OnInit } from '@angular/core';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import Pikaday from 'pikaday';

@Component({
  standalone: false,
  selector: 'invd-fm-date-picker',
  templateUrl: './fm-date-picker.component.html',
  styleUrls: ['./fm-date-picker.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class FmDatePickerComponent implements OnInit {
  @Input() classNames: string;
  @Input() datePickerId: string;
  @Input() placeholderText: string;
  @Input() dateValue = 'mm/dd/yyyy';
  @Input() disableWeekends = true;
  @Output() dateValueChange = new EventEmitter();

  private datePicker: Pikaday;

  private el = inject(ElementRef);

  ngOnInit(): void {
    const inputElement: HTMLElement = this.el.nativeElement.children[0];
    inputElement.setAttribute('id', this.datePickerId);
    this.datePicker = new Pikaday({
      field: inputElement,
      format: 'MM/DD/YYYY',
      disableWeekends: this.disableWeekends,
    });
    if (+this.dateValue) {
      this.initDateValue(this.dateValue);
    }
  }

  public initDateValue(val) {
    const newDate = new Date(val).toLocaleString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
    this.dateValue = newDate;
    this.datePicker.setDate(newDate);
  }

  dateInput() {
    this.datePicker.setDate(this.dateValue);
  }

  dateSelected($event) {
    const selectedDate = $event.target.value as any;
    this.dateValueChange.emit(selectedDate);
  }

  @Input()
  set datePickerValue(dateValue: string) {
    this.dateValue = dateValue;
  }

  private setCalendarDate(_date: Date) {
    const inputElement: HTMLElement = this.el.nativeElement.children[0];
    inputElement.setAttribute('id', this.datePickerId);
    this.datePicker.destroy();
    this.datePicker = new Pikaday({ field: inputElement, format: 'MM/DD/YYYY' });
  }
}
